import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { GenesysCloudService } from 'src/app/services/genesys-cloud.service';
import { LogService } from 'src/app/services/log.service';
import { RootScopeService } from 'src/app/services/root-scope.service';
import * as Constants from '../../models/Constants';
import { LogoutBusinessLogicService } from 'src/app/services/logout-business-logic.service';
import { ApiService } from 'src/app/services/api.service';
import { TbaBusinessLogicService } from 'src/app/services/tba-business-logic.service';
import { environment } from 'src/environments/environment';
import buildInfo from 'src/build';
import { DatabaseSelectorComponent } from '../database-selector/database-selector.component';
import { BatchAlertService } from 'src/app/services/batch-alert.service';



@Component({
  selector: 'app-user-profile-data-card',
  templateUrl: './user-profile-data-card.component.html',
  styleUrls: ['./user-profile-data-card.component.scss'],
})
export class UserProfileDataCardComponent implements OnInit {
  iconConfig: any;
  iconConfig2: any;
  isDisplay = false;
  isShown: boolean = false;
  finalShowProfileCardVal: boolean = false;
  items: { name: string; selected: boolean; id: string }[];
  showAngularVersion: any = "";
  showTimeStamp: any = "";
  showFullHash: any = "";
  simulatorOn: boolean = false;
  simulatorOff: boolean = false;

  currentYear: number = new Date().getFullYear();
 

  constructor(
    public dialog: MatDialog,

    public rootScope: RootScopeService,
    private elementRef: ElementRef,
    private apiService: ApiService,
    public logOutService: LogoutBusinessLogicService,
    private genesysCloudService: GenesysCloudService,
    public batchAlertService : BatchAlertService
  ) {
    this.items = this.rootScope.items;

    this.iconConfig = {
      iconName: 'xmark',
      iconType: 'light',
    };
    this.iconConfig2 = {
      iconName: 'circle-info',
      iconType: 'light',
    };
    this.showAngularVersion = environment.version
    this.showTimeStamp = buildInfo.timestamp
    this.showFullHash = buildInfo.git.fullHash

  }

  ngOnInit(): void { 
    this.rootScope.simulationData.isSimulationToggleOn= false;
  }
 
  /**
   * Below method is called when user tries to
   * open user profile data card
   */
  showDataCard() {
    this.finalShowProfileCardVal = true;
  }

  closeDataCard() {
    this.finalShowProfileCardVal = false;
  }

  /**
   * Below method is called when
   * user click on logout button
   */
  userLogout() {
    // console.log(this.rootScope.customerTabs.length);
   if (this.rootScope.simulationRecords?.length > 0) {
      this.exitSimulator(Constants.END_ALL_SIMULATIONS_MSG_LOGOUT);
    }
    else{
       this.logOutService.validateLogOut(this);
    }

    // if (this.rootScope.customerTabs.length > 1) {
    //   if (localStorage.getItem('isLiveCall') == 'true') {
    //     this.rootScope.openDialog({
    //       title: '',
    //       subheading:'',
    //       message: Constants.user_logout_MSGACTIVECALL,
    //       firstbutton: '',
    //       secondbutton: Constants.buttonEnum.gotIt,
    //       crossIcon: false,
    //       comingFrom: 'userprofile',
    //       additionalClass: 'logout-modal',
    //     });
    //   }
    //   else if (localStorage.getItem('isLiveChat') == 'true') {
    //     this.rootScope.openDialog({
    //       title: '',
    //       subheading:'',
    //       message: Constants.user_logout_MSGACTIVECHATS,
    //       firstbutton: '',
    //       secondbutton: Constants.buttonEnum.gotIt,
    //       crossIcon: false,
    //       comingFrom: 'userprofile',
    //       additionalClass: 'logout-modal',
    //     });
    //   }
    //   else {
    //     this.rootScope.openDialog({
    //       title: '',
    //       subheading:'',
    //       message: Constants.user_logout_MSGOPENACCOUNT,
    //       firstbutton: '',
    //       secondbutton: Constants.buttonEnum.gotIt,
    //       crossIcon: false,
    //       comingFrom: 'userprofile',
    //       additionalClass: 'logout-modal',
    //     });
    //   }
    // }
    // else { this.rootScope.closeAllKcWindow();
    //   let linkMessageString = this.rootScope.linkTrackingMap?.get(Constants.DASHBOARD_LINK_TRACKING);
    //   if(linkMessageString){
    //     this.rootScope.linkTrackingMap?.delete(Constants.DASHBOARD_LINK_TRACKING);
    //     let logObj = this.rootScope.createAngluarLogsObject(linkMessageString,'usage','N/A');
    //     this.genesysCloudService.awsSQSService.sendAngularLogsToSQS(logObj);
    //   }

    //   this.apiService.userLogout();
    //   this.tbaService.closeTbaLogout();



    // }
  }


  // ShowPopup() {
  //   this.rootScope.openDialog({
  //     title: '',
  //     message: Constants.user_logout_MSG,
  //     firstbutton: '',
  //     secondbutton: Constants.buttonEnum.gotIt,
  //     crossIcon: false,
  //     comingFrom: 'userprofile',
  //     additionalClass: 'logout-modal',
  //   });
  // }

  startSimulator() {
    this.rootScope.openDialog({
      title: 'Starting a simulation?',
      subheading: '',
      message: "Simulation Mode is for training and testing purposes. Registration with ALIS is not supported while in Simulation Mode.",
      firstbutton: 'Cancel',
      secondbutton: 'Continue',
      crossIcon: false,
      comingFrom: 'userprofile',
      additionalClass: 'start-simulator',
    });

  }
  
  /**
   * @author Amarjeet
   * Exits the simulator mode with appropriate user confirmation dialogs.
   * 
   * If there are multiple customer tabs open or simulation records present, displays a confirmation dialog
   * to warn the user about ending simulations or closing customer accounts. Otherwise, directly turns
   * off simulation mode.
   * 
   * @param logoutMsg - Optional custom message to display in the confirmation dialog. If not provided,
   *                    uses default messages based on the presence of simulation records.
   * 
   */
  exitSimulator(logoutMsg?:string) {
    if ((this.rootScope.customerTabs && this.rootScope.customerTabs.length > 1) || (this.rootScope.simulationRecords && this.rootScope.simulationRecords.length > 0)) {
      let textMsg = this.rootScope.simulationRecords.length > 0 ? Constants.END_ALL_SIMULATIONS_OFF_MSG : Constants.CLOSE_ALL_OPEN_CUSTOMER_ACCOUNTS_SIMULATIONS_OFF_MSG;
      this.rootScope.openDialog({
        title: '',
        subheading: '',
        message: logoutMsg ? logoutMsg : textMsg,
        firstbutton: '',
        secondbutton: 'Got it',
        crossIcon: false,
        comingFrom: 'userprofile',
        additionalClass: 'exit-simulator',
      });
    }
    else {
      this.rootScope.turnSimulationModeOff();
    }
  }



  
  closeAllAccount() {
    this.rootScope.openDialog({
      title: '',
      subheading: '',
      message: "Close all open customer accounts before switching the Database.",
      firstbutton: '',
      secondbutton: 'Got it',
      crossIcon: false,
      comingFrom: 'userprofile',
      additionalClass: 'closeAllAccount',
    });
  }

  /* istanbul ignore next */
  // closeAllActiveAccount() {
  //   this.rootScope.openDialog({
  //     title: '',
  //     subheading: '',
  //     message: "You must end all active interactions before switching the Database.",
  //     firstbutton: '',
  //     secondbutton: 'Gotit',
  //     crossIcon: false,
  //     comingFrom: 'userprofile',
  //     additionalClass: 'closeAllAccount',
  //   });
  // }


openSimulationModeDialog(){
   this.rootScope.openDialog({
      title: '',
      subheading: '',
      message: Constants.CLOSE_ALL_OPEN_CUSTOMER_ACCOUNTS_SIMULATIONS_ON_MSG,
      firstbutton: '',
      secondbutton: 'Got it',
      crossIcon: false,
      comingFrom: 'userprofile',
      additionalClass: 'openSimulationModeDialog',
    });
}

  openDatabaseSelector() {
    if (this.rootScope.customerTabs.length > 1) {
      this.closeAllAccount()
    }
    else {
      this.dialog.open(DatabaseSelectorComponent, {
        panelClass: 'database-selector',
        backdropClass: 'custom-overlay',
        disableClose: true,
        id: 'databaseSelector'
      });
    }
  }

  
  onToggleChange(event: any) {
    this.finalShowProfileCardVal = false;

    if (event?.detail?.isOn) {
      if (this.rootScope.customerTabs.length > 1) {
      this.openSimulationModeDialog();
    }else{
      console.log("start the simulator ");
      this.startSimulator();
    }
    }
    else {
     // this.rootScope.turnSimulationModeOff();
      this.exitSimulator();

    }
  }

  /**
   * Below method turn on/off the Batch Alert Tab from the user profile.
   * @param event 
   */
  onToggleChangeBatchAlert(event:any){
    this.finalShowProfileCardVal = false;
    this.batchAlertService.createAlertForm.reset();
    this.batchAlertService.adminForm.reset();
    if (event?.detail?.isOn) {
      this.batchAlertService.turnBatchAlertModeOn();
    }
    else {
      this.batchAlertService.turnBatchAlertModeOff();
    }

  }

  openHelpPdf() {
    // this.apiService.createBatchAlertAPI().subscribe((data)=>{

    // })
    let helpUrl = this.rootScope.getObjFromConfigObj(Constants.USER_PROFILE_HELP_URL)?.['fieldValue'];

    this.rootScope.openNewTab(helpUrl);
  }



  openPrivacyLink() {
    this.rootScope.openNewTab(Constants.PRIVACY_URL);
  }

  @HostListener('document:click', ['$event'])
  /*istanbul ignore next */
  documentClick(event: MouseEvent) {
    // console.log('event ', event.target);
    // console.log(
    //   'target',
    //   this.elementRef.nativeElement.contains(event.target as HTMLElement)
    // );
    const targetElement = event.target as HTMLElement;
    if (
      targetElement &&
      !this.elementRef.nativeElement.contains(targetElement)
    ) {
      this.finalShowProfileCardVal = false;
    }
  }
  /**
   * Check if ALIS is registered
   * @returns 
   */
  checkTogglediasabled() {
    if (sessionStorage.getItem('connectToGenesys') == 'true') {
      return true;
    }
    return false;
  }
}
